
import '../assets/css/component.css';
import { mainAssets } from'../services/constant';
import { useRouter } from '../router/hooks/index';
import { useGlobalContext } from './../services/GlobalContext';
import axios from 'axios';
import API_BASE_URL , {Providers} from '../services/Config';
export default function PoliciesCard({ valid, setValid ,toast}) {
    const {  setData ,setloading } = useGlobalContext();

    const token = localStorage.getItem('authToken');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const router = useRouter();

    const handleChange = (e) => {
        const value = e.target.value.trim(); // Trim whitespace from both ends
        setValid(value);
    }
    const handleClick = () => {
        
        setloading(true);
        axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}/search-policies-by-code`, {
            code: valid
        }, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {
            setloading(false);
            if(res.data.size === 0){
                setValid('')
                
                toast.error('não há quaisquer dados');
                return;
            } 
            else{
                localStorage.setItem('network_id', res.data.elements[0].network_id);
                axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}/detailed-view`, {
                    policy_id : res.data.elements[0].policy_id,
                    clientservice_id : res.data.elements[0].clientservice_id,
                    quote_id: res.data.elements[0].quote_id,
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json',
                    }
                })
                .then((res) => {
                    setData(res.data);
                    localStorage.setItem('policy_id', valid);
                    if(res.data.policies[0].quote.protected_assets.length > 1){
                        router.push('/animal');
                    } else {
                        router.push('/animal/manage');
                    }
                })
                .catch((err) => {
                    toast.error(err.message);   
                })
            }
        }).catch((err) => {
            toast.error(err.message);   
            setloading(false);
        })
    }
    return (
        <div className="policies_card">
            <div className="card_icon">
                <img src={mainAssets.ic_security} alt="" />
            </div>

            <div className="card_title font-18-900">
                <span className="font-color">APÓLICES</span>
            </div>
            <div className="card_content font-14-400">
                Insira o número da apólice para encontrar <br /> o seguro associado ao animal.
            </div>
            <div className="card_input">
                <input type="text" placeholder="Inserir nº apólice..." className="card_input_text font-14-500" value={valid} onChange={(e) => handleChange(e)} />
            </div>
            <div className="card_button">
                {
                    valid === '' ?
                        (<button className="btn-primary font-14-700" disabled>VALIDAR</button>)
                        :
                        (<button className="btn-secondly font-14-700 " onClick={() => handleClick()}>VALIDAR</button>)
                }

            </div>
        </div>
    );
}